import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { House, MapPin, Ruler, FileText } from '@phosphor-icons/react';

const items = [
    { to: '/app', label: 'Home', icon: House, testid: 'nav-home' },
    { to: '/app/floorplan', label: 'Plan', icon: MapPin, testid: 'nav-floorplan' },
    { to: '/app/tools', label: 'Tools', icon: Ruler, testid: 'nav-tools' },
    { to: '/app/report', label: 'Report', icon: FileText, testid: 'nav-report' },
];

export default function BottomNav() {
    const { pathname } = useLocation();
    return (
        <nav
            data-testid="bottom-nav"
            className="fixed bottom-0 left-0 right-0 bg-white border-t border-[#18181B] z-40 no-print"
            style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
        >
            <ul className="grid grid-cols-4">
                {items.map(({ to, label, icon: Icon, testid }) => {
                    const active = pathname === to || (to !== '/app' && pathname.startsWith(to));
                    const isHome = to === '/app' && pathname === '/app';
                    const isActive = active || isHome;
                    return (
                        <li key={to} className="border-r border-[#E4E4E7] last:border-r-0">
                            <Link
                                to={to}
                                data-testid={testid}
                                className={`flex flex-col items-center justify-center py-3 text-[11px] uppercase tracking-[0.18em] transition-all duration-150 ${
                                    isActive ? 'bg-[#09090B] text-white' : 'text-[#52525B] hover:text-[#09090B]'
                                }`}
                            >
                                <Icon size={22} weight={isActive ? 'fill' : 'regular'} />
                                <span className="mt-1">{label}</span>
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}
